import React from "react";
import styled, { css } from "react-emotion";

const TextAreaStyle = styled("textarea")`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "20px")};
  resize: none;
  /* min-height: 7rem; */
  background: ${(props) => (props.background ? props.background : "none")};
  color: ${(props) => (props.textColor ? props.textColor : "#1f3747")};

  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : 0)};
  outline: none;
  box-shadow: none;
  height: ${(props) => (props.height ? props.height : "11rem")};
  border: 1px solid #979797;
  padding: 6px 10px;
  transition: 0.4s;
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "11rem")};
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

const TextArea = (props) => {
  const updateText = (e) => {
    props.onChange(e.currentTarget.value);
  };

  return (
    <TextAreaStyle
      {...props}
      value={props.text}
      placeholder={props.placeholder || "enter text here"}
      onChange={updateText}
      maxLength={props.maxLength ? props.maxLength : 500}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      disabled={props.disabled}
    />
  );
};

export default TextArea;
